import React, { useState } from 'react'
import { chevron_right } from '../Images/Icons';
import View from './View';

const Accordion = ({title, content, ...props}) => {

    const [state, setState] = useState({ isVisible: false, });

    const onAccordion = () => {
        setState({ isVisible: !state.isVisible });
     }

    return (
        <div  style={{ minHeight: 44, background: 'white', borderRadius: 8, padding: 12, ...props.style }}>
            <View onClick={onAccordion} justifyContent="space-between" style={{ cursor: 'pointer' }}>
                <span style={{ fontSize: 14, fontWeight: 600, color: '#292929' }}>{title}</span>
                <img src={chevron_right} alt="" style={state.isVisible? {transition: 'transform .5s', transform: 'rotate(-90deg)'}:{transition: 'transform .5s', transform: 'rotate(90deg)'}}/>
            </View>
            <div className={state.isVisible ? 'content_show' : 'content_hide'}>
                <div style={{ marginTop: 12, fontSize: 14, fontWeight: 400, color: '#515151' }}>
                    {content}
                </div>
            </div>
        </div>
    )
}

export default Accordion